import React from "react";
import PropTypes from "prop-types";

export default function RestaurantImage(props) {
  const restaurant = props.restaurant;

  return (
    <div className="restaurant-review-margin">
      <div
        className="restaurant-details-reviews-count"
        style={{ marginBottom: "30px", float: "left", marginTop: "20px" }}
      >
        {restaurant.rating_count} utenti facebook hanno valutato{" "}
        {this.props.restaurantName}
      </div>
      <div className="restaurant-facebook-reviews-container">
        {restaurant.link ? (
          <a rel="noreferrer" target="blank" href={restaurant.link}>
            <i className="fa fa-facebook" />
          </a>
        ) : (
          <i className="fa fa-facebook" />
        )}
        <div className="restaurant-facebook-rating">
          <span
            className="restaurant-facebook-score"
            style={{ fontSize: "35px" }}
          >
            {restaurant.overall_star_rating}
          </span>
          <span className="restaurant-facebook-score">su 5</span>
          <span className="restaurant-facebook-rating-count">
            In base alle opinioni di {restaurant.rating_count} utenti facebook
          </span>
        </div>
      </div>
    </div>
  );
}

RestaurantImage.propTypes = {
  restaurant: PropTypes.object.isRequired
};
